export class FindingEntry {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "detectorType",
            "baseName": "detectorType",
            "type": "DetectorType",
            "format": ""
        },
        {
            "name": "evidenceType",
            "baseName": "evidenceType",
            "type": "string",
            "format": ""
        },
        {
            "name": "evidenceDisplayName",
            "baseName": "evidenceDisplayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "displayPath",
            "baseName": "displayPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "objectType",
            "baseName": "objectType",
            "type": "FindingObjectType",
            "format": ""
        },
        {
            "name": "conclusion",
            "baseName": "conclusion",
            "type": "SecurityScanConclusion",
            "format": ""
        },
        {
            "name": "riskLevel",
            "baseName": "riskLevel",
            "type": "RiskLevel",
            "format": ""
        },
        {
            "name": "riskReason",
            "baseName": "riskReason",
            "type": "string",
            "format": ""
        },
        {
            "name": "justification",
            "baseName": "justification",
            "type": "string",
            "format": ""
        },
        {
            "name": "score",
            "baseName": "score",
            "type": "number",
            "format": "float"
        },
        {
            "name": "anomalyGraph",
            "baseName": "anomalyGraph",
            "type": "AnomalyGraphData",
            "format": ""
        },
        {
            "name": "sensitiveDataLocations",
            "baseName": "sensitiveDataLocations",
            "type": "Array<FindingSensitiveDataLocation>",
            "format": ""
        },
        {
            "name": "resourceReference",
            "baseName": "resourceReference",
            "type": "ResourceReference",
            "format": ""
        },
        {
            "name": "snapshots",
            "baseName": "snapshots",
            "type": "Array<SnapshotReference>",
            "format": ""
        },
        {
            "name": "excludedSince",
            "baseName": "excludedSince",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "FindingStatus",
            "format": ""
        },
        {
            "name": "resolvedAt",
            "baseName": "resolvedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return FindingEntry.attributeTypeMap;
    }
    constructor() {
    }
}
